// Generated by ReScript, PLEASE EDIT WITH CARE

import Classnames from "classnames";
import * as Css_Js_Core from "bs-css/src/Css_Js_Core.bs.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";
import * as Kontent$PrezzeeRibbon from "../../personal/Kontent/Kontent.bs.js";
import * as ThemeContext$PrezzeeRibbon from "../../../context/ThemeContext/ThemeContext.bs.js";
import * as ReactFontawesome from "@fortawesome/react-fontawesome";
import * as Theme__Animation$PrezzeeRibbon from "../../../theme/Theme__Animation.bs.js";
import * as Theme__Responsive$PrezzeeRibbon from "../../../theme/Theme__Responsive.bs.js";
import * as FaArrowRight from "@fortawesome/pro-regular-svg-icons/faArrowRight";

function themeStyles(theme) {
  var match = theme.components;
  var promoTiles = match.promoTiles;
  return BsCssJs$PrezzeeRibbon.style([
              BsCssJs$PrezzeeRibbon.borderRadius(theme.borderRadius),
              BsCssJs$PrezzeeRibbon.color(promoTiles.color),
              BsCssJs$PrezzeeRibbon.backgroundColor(promoTiles.backgroundColor)
            ]);
}

var wrapper = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.width(BsCssJs$PrezzeeRibbon.pct(100)),
      BsCssJs$PrezzeeRibbon.position("relative"),
      BsCssJs$PrezzeeRibbon.display("flex"),
      BsCssJs$PrezzeeRibbon.alignItems("flexEnd"),
      BsCssJs$PrezzeeRibbon.justifyContent("spaceBetween"),
      BsCssJs$PrezzeeRibbon.boxSizing("borderBox"),
      BsCssJs$PrezzeeRibbon.height(BsCssJs$PrezzeeRibbon.px(300)),
      BsCssJs$PrezzeeRibbon.minHeight(BsCssJs$PrezzeeRibbon.px(164)),
      BsCssJs$PrezzeeRibbon.paddingBottom(BsCssJs$PrezzeeRibbon.px(12)),
      BsCssJs$PrezzeeRibbon.paddingLeft(BsCssJs$PrezzeeRibbon.px(22)),
      BsCssJs$PrezzeeRibbon.paddingRight(BsCssJs$PrezzeeRibbon.px(22)),
      BsCssJs$PrezzeeRibbon.overflow("hidden"),
      BsCssJs$PrezzeeRibbon.textDecoration("none"),
      BsCssJs$PrezzeeRibbon.transitionDuration(Theme__Animation$PrezzeeRibbon.regular),
      BsCssJs$PrezzeeRibbon.transitionTimingFunction("easeOut"),
      BsCssJs$PrezzeeRibbon.transitionProperty("transform box-shadow"),
      BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.tabletOrDesktop, [
            BsCssJs$PrezzeeRibbon.height(BsCssJs$PrezzeeRibbon.pct(100)),
            BsCssJs$PrezzeeRibbon.paddingTop(BsCssJs$PrezzeeRibbon.px(35))
          ]),
      BsCssJs$PrezzeeRibbon.selector(":hover", [
            BsCssJs$PrezzeeRibbon.cursor("pointer"),
            BsCssJs$PrezzeeRibbon.transform(BsCssJs$PrezzeeRibbon.translateY(BsCssJs$PrezzeeRibbon.px(-4))),
            BsCssJs$PrezzeeRibbon.boxShadow(Css_Js_Core.Shadow.box(BsCssJs$PrezzeeRibbon.px(11), BsCssJs$PrezzeeRibbon.px(9), BsCssJs$PrezzeeRibbon.px(30), undefined, undefined, BsCssJs$PrezzeeRibbon.rgba(0, 0, 0, {
                          NAME: "percent",
                          VAL: 15.0
                        })))
          ])
    ]);

function iconThemeStyles(theme) {
  var match = theme.components;
  return BsCssJs$PrezzeeRibbon.style([BsCssJs$PrezzeeRibbon.color(match.promoTiles.iconColor)]);
}

var icon = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.fontSize(BsCssJs$PrezzeeRibbon.px(22)),
      BsCssJs$PrezzeeRibbon.lineHeight(BsCssJs$PrezzeeRibbon.px(32)),
      BsCssJs$PrezzeeRibbon.zIndex(1)
    ]);

var Styles = {
  themeStyles: themeStyles,
  wrapper: wrapper,
  iconThemeStyles: iconThemeStyles,
  icon: icon
};

function PromoTile(props) {
  var iconStyle = props.iconStyle;
  var className = props.className;
  var className$1 = className !== undefined ? className : "";
  var iconStyle$1 = iconStyle !== undefined ? iconStyle : "";
  var theme = ThemeContext$PrezzeeRibbon.useTheme(undefined);
  return JsxRuntime.jsx(Kontent$PrezzeeRibbon.Consumer.make, {
              children: JsxRuntime.jsxs("div", {
                    children: [
                      props.children,
                      JsxRuntime.jsx(ReactFontawesome.FontAwesomeIcon, {
                            icon: FaArrowRight.faArrowRight,
                            className: Classnames([
                                  icon,
                                  iconThemeStyles(theme),
                                  iconStyle$1
                                ])
                          })
                    ],
                    className: Classnames([
                          wrapper,
                          themeStyles(theme),
                          className$1
                        ])
                  })
            });
}

var Content;

var make = PromoTile;

export {
  Content ,
  Styles ,
  make ,
}
/* wrapper Not a pure module */
